export enum IMessageType{
    Sent = 0,
    Received = 1,
}
